import { render } from "./candidate-header.vue?vue&type=template&id=2f7593d1"
import script from "./candidate-header.vue?vue&type=script&lang=js"
export * from "./candidate-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__